import { useTranslation } from "@redotech/redo-i18n";
import ChevronDownIcon from "@redotech/redo-icons/chevron-down.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@redotech/redo-web/components/ui/dropdown-menu";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export type AmountType = "fixed" | "percentage";

/**
 * Trailing $/% unit picker for amount inputs (pass as `trailingActions` on a
 * RedoTextInput).
 */
export const AmountTypeDropdown = memo(function AmountTypeDropdown({
  amountType,
  setAmountType,
  disabled,
}: {
  amountType: AmountType;
  setAmountType(type: AmountType): void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const symbol = amountType === "fixed" ? "$" : "%";

  if (disabled) {
    return (
      <Text fontSize="sm" p="xs" textColor="secondary">
        {symbol}
      </Text>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <RedoButton
          hierarchy="tertiary"
          IconTrailing={ChevronDownIcon}
          size="xs"
          text={symbol}
          type="button"
        />
      </DropdownMenuTrigger>
      {/* design-allow: zIndex keeps the dropdown above the settings panel. */}
      <DropdownMenuContent align="end" style={{ zIndex: 1000 }}>
        <DropdownMenuItem onClick={() => setAmountType("fixed")}>
          {t("$ Fixed dollar amount")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setAmountType("percentage")}>
          {t("% Percentage")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
});
